export function roleLabel(role) {
  if (role === 'admin') return 'Admin';
  return 'User';
}
